import { render, staticRenderFns } from "./CardTarjaEnqueteAngelica.vue?vue&type=template&id=16db6c6e&scoped=true"
import script from "./CardTarjaEnqueteAngelica.vue?vue&type=script&lang=js"
export * from "./CardTarjaEnqueteAngelica.vue?vue&type=script&lang=js"
import style0 from "./CardTarjaEnqueteAngelica.vue?vue&type=style&index=0&id=16db6c6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16db6c6e",
  null
  
)

export default component.exports